import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const About = () => {
  const features = [
    {
      title: "Proactive Prevention",
      description: "iFLO Pro's bio-enzymatic formula continuously cleans A/C drain lines, preventing the buildup of Zooglea, dirt, and debris that cause clogs",
      icon: "🛡️",
      color: "bg-blue-50"
    },
    {
      title: "Reduce Callbacks",
      description: "Minimize emergency service calls related to drain line blockages, freeing up your technicians for other jobs",
      icon: "📱",
      color: "bg-green-50"
    },
    {
      title: "Potential for Recurring Revenue",
      description: "iFLO Pro is a valuable maintenance solution that can be part of and create more ongoing service agreements",
      icon: "💰",
      color: "bg-purple-50"
    },
    {
      title: "Improve Customer Retention",
      description: "iFLO Pro keeps you in contact with your customers and gives you the ability to provide top-of-the-line service that will stand out against competition",
      icon: "🤝",
      color: "bg-yellow-50"
    }
  ];

  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        className="text-center mb-16"
      >
        <h1 className="text-5xl font-bold text-gray-900 mb-6">
        About iFLO Pro®
        </h1>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
        The smart, automated solution that ensures smooth A/C operation and happier customers.
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3 }}
        id="features"
        className="grid md:grid-cols-2 gap-8 mb-16"
      >
        {features.map((feature, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: index * 0.2 }}
            whileHover={{ scale: 1.03 }}
            className={`${feature.color} rounded-xl p-6 shadow-sm hover:shadow-lg transition-all duration-300`}
          >
            <div className="flex items-start space-x-4">
              <span className="text-4xl">{feature.icon}</span>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {feature.title}
                </h3>
                <p className="text-gray-600">{feature.description}</p>
              </div>
            </div>
          </motion.div>
        ))}
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.6 }}
        className="bg-gradient-to-r from-yellow-50 to-yellow-100 rounded-xl p-8 shadow-lg mb-16"
      >
        <h2 className="text-3xl font-bold text-gray-900 mb-4">
          Why Choose iFLO Pro®?
        </h2>
        <p className="text-gray-700 mb-6 text-lg">
        iFLO PRO is the preferred choice for property managers, homeowners, and HVAC professionals across the country. 
        Our reliable technology has made us the industry leader in preventing unnecessary service calls, frustrated clients, and spontaneous water leaks
        </p>
        <motion.div 
          className="flex flex-wrap gap-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8 }}
        >
          <Link to="/dashboard/install">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-yellow-500 text-white px-6 py-3 rounded-lg font-medium hover:bg-yellow-600 transition-colors duration-300"
            >
              Get Started Now
            </motion.button>
          </Link>
          <Link to="/dashboard/education">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-white text-gray-800 px-6 py-3 rounded-lg font-medium hover:bg-gray-50 transition-colors duration-300 border border-gray-200"
            >
              Learn More
            </motion.button>
          </Link>
        </motion.div>
      </motion.div>

      {/*<motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1 }}
        className="text-center"
      >
        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          Ready to Transform Your Business?
        </h2>
        <p className="text-gray-600 mb-8">
          Join thousands of satisfied customers who trust iFLO Pro
        </p>
        <motion.div
          whileHover={{ scale: 1.05 }}
          className="inline-block bg-gradient-to-r from-yellow-400 to-yellow-600 text-white px-8 py-3 rounded-lg font-medium shadow-lg hover:shadow-xl transition-all duration-300"
        >
          <Link to="/dashboard/contact">Contact Sales</Link>
        </motion.div>
      </motion.div>*/}
    </div>
  );
};

export default About;
